(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionDetailController', QuestionDetailController);

    QuestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Question', 'Section', 'QuestionOption'];

    function QuestionDetailController($scope, $rootScope, $stateParams, entity, Question, Section, QuestionOption) {
        var vm = this;
        vm.question = entity;
        vm.load = function (id) {
            Question.get({id: id}, function(result) {
                vm.question = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:questionUpdate', function(event, result) {
            vm.question = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
